/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/sort-comp */
/* eslint-disable max-len */
/* eslint-disable arrow-parens */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import {
  Button,
  Modal,
  Dimmer,
  Loader,
} from 'semantic-ui-react';
import CloseSVG from '../../assets/icons/close.svg';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import PaymentPlanForm from './PaymentPlanForm';

class PaymentPlanModal extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onClose: PropTypes.func,
    loading: PropTypes.bool,
    open: PropTypes.bool,
    token: PropTypes.string,
    onSubmit: PropTypes.func,
    paymentSchedules: PropTypes.arrayOf(PropTypes.shape()), // all payment schedule
    bookingPaymentPlan: PropTypes.shape(),
    contractPaymentSchedules: PropTypes.arrayOf(PropTypes.shape()), //  list pending / billed cps
    bookingData: PropTypes.shape(),
    t: PropTypes.func,
  }

  constructor(props) {
    super(props);

    this.state = {
      paymentScheduleID: '',
      isSaveDisabled: true,
    };
  }

  handleSetState = state => this.setState(prev => ({ ...prev, ...state }));

  handlePlanSelected = (paymentScheduleID) => {
    this.setState({ paymentScheduleID });
  }

  handleSaveDisabled = (isSaveDisabled) => {
    this.setState({ isSaveDisabled });
  }

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleSubmit = () => {
    this.form.getWrappedInstance().handleSubmit();
  }

  render() {
    const {
      loading,
      open,
      bookingPaymentPlan,
      t,
    } = this.props;
    const { paymentScheduleID } = this.state;

    // workaround to show dropdown option list overflow outside of modal
    const noBpp = bookingPaymentPlan && bookingPaymentPlan.id === '';

    return (
      <Modal
        closeOnDimmerClick={false}
        size="large"
        open={open}
        onClose={() => this.handleClose()}
        className="paymentPlanModal"
      >
        <section className="modal-header text-header">
          {`${t(noBpp ? 'Add' : 'Edit', { ns: TRANSLATION_FILES.translation })} ${t('Payment Plan')}`}
          <Button
            basic
            className="closeButton"
            onClick={() => this.handleClose()}
          >
            <img src={CloseSVG} alt="close" />
          </Button>
        </section>
        <Dimmer
          inverted style={{ zIndex: 1 }}
          active={loading}
        >
          <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
        </Dimmer>
        <Modal.Content className={`modal-content${noBpp && paymentScheduleID === '' ? ' modal-content-overflow' : ''}`}>
          <PaymentPlanForm
            ref={(ref) => { this.form = ref; }}
            token={this.props.token}
            onSubmit={this.props.onSubmit}
            bookingPaymentPlan={bookingPaymentPlan}
            contractPaymentSchedules={this.props.contractPaymentSchedules}
            bookingData={this.props.bookingData}
            onPaymentPlanSelect={this.handlePlanSelected}
            onSaveDisabled={this.handleSaveDisabled}
          />
        </Modal.Content>
        <Modal.Actions className="text-center">
          <Button
            type="submit"
            content={t('Save', { ns: TRANSLATION_FILES.translation })}
            disabled={this.state.isSaveDisabled}
            loading={loading}
            onClick={this.handleSubmit}
            className="submit-button text-title"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(PaymentPlanModal);



// WEBPACK FOOTER //
// ./src/components/PaymentPlan/PaymentPlanModal.jsx